export class NativeStreamAggregationEntryRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "paneMinutes",
            "baseName": "paneMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "windowMinutes",
            "baseName": "windowMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "lateMinutes",
            "baseName": "lateMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "lookback",
            "baseName": "lookback",
            "type": "NativeStreamAggregationEntryLookback",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<NativeStreamAggregationEntryMetric>",
            "format": ""
        },
        {
            "name": "rule",
            "baseName": "rule",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationEntryRule.attributeTypeMap;
    }
    constructor() {
    }
}
